import { atomFamily, atomWithRefresh } from 'jotai/utils';
import { guardedClient } from '../../../auth/api/clients';
import { customerSchema } from '@minutes-system/backend/src/api/customers/schema';
import fetchAndValidate from '../../../../lib/fetchAndValidate';

export const customerQueryAtom = atomFamily((customerId: number) =>
  atomWithRefresh(() =>
    fetchAndValidate(
      guardedClient.customers[':id'].$get({ param: { id: String(customerId) } }) as Promise<Response>,
      customerSchema
    )
  )
);
